import {MatchVideoEmbeddingEvent} from './MatchVideoEmbeddingEvent';

export class MatchVideoEmbeddingDeleted extends MatchVideoEmbeddingEvent {}
